import { render, staticRenderFns } from "./GuestsTab.vue?vue&type=template&id=1905af20&"
import script from "./GuestsTab.vue?vue&type=script&lang=ts&"
export * from "./GuestsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports